export const DEBUG_LINKS_POSSIBILITY = "DEBUG_LINKS_POSSIBILITY";
